// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__j6UCf","container":"style_container__OxETA","icon":"style_icon__LpyOH","block":"style_block__WWugQ"};